import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import * as grid from 'view/styles/grid';
import Lozenge from '@atlaskit/lozenge';
import { AutoScaledImage } from '@atlassian/help-center-common-component/auto-scaled-image';
import i18n from './messages';
import { UserPickerItemSection } from './styled';

export interface Props {
    icon: React.ReactNode;
    name: string;
    email?: string;
    isNew?: boolean;
}

const UserPickerItem: React.StatelessComponent<Props> = ({ icon, name, email, isNew }) => {
    const content = email ? `${name} (${email})` : name;
    const iconComponent = typeof icon === 'string' ? <AutoScaledImage src={icon} /> : icon;

    return (
        <>
            <UserPickerItemSection>
                <IconCardLayout leftIcon={iconComponent} content={content} iconSize={16} iconMargin={8} padding={0} />
            </UserPickerItemSection>
            {isNew && (
                <UserPickerItemSection marginLeft={grid.multiple(2).unitless}>
                    <Lozenge appearance="new">
                        <FormattedMessage {...i18n.newUserLozengeText} />
                    </Lozenge>
                </UserPickerItemSection>
            )}
        </>
    );
};

export default UserPickerItem;
